import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { AgencyFeeInterface } from "../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import Translator from "../../Translation/Translator";

export default function* agencyFeeDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_REQUEST
    });

    yield call(Http.delete, `agency-fees/${action.payload?.id}`);

    const agencyFee: AgencyFeeInterface = action.payload?.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_SUCCESS,
      payload: {
        agencyFee: agencyFee
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-agency-fee-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_DELETE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAgencyFeeDelete() {
  yield takeEvery(Constants.GLOBAL_AGENCY_FEE_DELETE_START, agencyFeeDelete);
}
